import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Maximum = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M14 20H6V6H14M14.67 4H13V2H7V4H5.33C4.6 4 4 4.6 4 5.33V20.67C4 21.4 4.6 22 5.33 22H14.67C15.41 22 16 21.41 16 20.67V5.33C16 4.6 15.4 4 14.67 4ZM13 16H7V19H13V16ZM13 7H7V10H13V7ZM13 11.5H7V14.5H13V11.5Z" />
    <path d="M21 13H19V7H21V13ZM21 17H19V15H21V17Z" />
  </SvgIcon>
));

Maximum.displayName = 'Maximum';

export default Maximum;
